import { render } from "./ApiTransactionListComponent.vue?vue&type=template&id=630bb52f&scoped=true"
import script from "./ApiTransactionListComponent.vue?vue&type=script&lang=js"
export * from "./ApiTransactionListComponent.vue?vue&type=script&lang=js"

import "./ApiTransactionListComponent.vue?vue&type=style&index=0&id=630bb52f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630bb52f"]])

export default __exports__